import {
  BulkAssignEmployeesToPolicyDocument,
  BulkAssignEmployeesToPolicyMutationVariables,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

export const useBulkAssignEmployeesToPolicy = () => {
  const [bulkAssignEmployeesToPolicy, { loading }] = useMutation(
    BulkAssignEmployeesToPolicyDocument,
    {
      extractorFn: (data) => data.contractsMutations.bulkAssignContractsPayrollPolicy,
    }
  )

  return {
    fetching: loading,
    update({ employeeIds, payrollPolicyId }: BulkAssignEmployeesToPolicyMutationVariables) {
      return bulkAssignEmployeesToPolicy({
        variables: { employeeIds, payrollPolicyId },
      })
    },
  }
}
